<app-header [links]="links"></app-header>
<app-maintenance></app-maintenance>
<div class="app-body">
    <router-outlet />
    <electron-loader [visible]="isNavigating"></electron-loader>
</div>
<app-footer></app-footer>
